// Imports => React
import { useEffect, useMemo } from 'react';
import clsx from 'clsx';

// Imports => Constants
import { ICONS } from '@opp/ui-kit';

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcRichContent,
  AcIcon,
} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";

const _CLASSES = {
  MAIN: 'ac-no-internet-connection-notice-modal ac-modal--size-sm',
  CONTENT: 'ac-no-internet-connection-notice-modal__content',
};

const AcNoInternetConnectionNoticeModal = ({t}) => {
  useEffect(() => {
    return () => window.location.reload(false);
  }, []);

  const getContentClassNames = useMemo(() => {
    return clsx([_CLASSES.CONTENT]);
  }, []);

  const getStyleClassNames = useMemo(() => {
    return clsx([_CLASSES.MAIN]);
  }, []);

  return (
    <div className={getStyleClassNames}>
      <div className={getContentClassNames}>
        <AcContainer fluid className={'h-text--align-center'}>
          <AcRow>
            <AcColumn>
              <AcIcon
                icon={ICONS.WIFI_OFF}
                className={'h-margin-bottom-25 h-text--size-bigger'}
              />
            </AcColumn>
          </AcRow>

          <AcRow className={'h-margin-top-25'}>
            <AcColumn>
              <AcRichContent
                content={
                  `<p>${t('no-internet-text', 'There seems to be no internet connection. Check your connection and if necessary reload this page.', {ns: 'common'})}</p>`
                }
              />
            </AcColumn>
          </AcRow>
        </AcContainer>
      </div>
    </div>
  );
};

export default withTranslation(['common'])(AcNoInternetConnectionNoticeModal);
